import React from "react";
import { Routes, Route } from "react-router-dom";
import { AudioAuthProvider } from "./AudioAuthContext";
import { AudioAccessProvider } from "./AudioAccessContext";
import AudioHome from "./pages/AudioHome";
import AudioLogin from "./pages/AudioLogin";
import AudioAuthCallback from "./pages/AudioAuthCallback";
import AudioBooks from "./pages/AudioBooks";
import AudioBook from "./pages/AudioBook";
import AudioVachana from "./pages/AudioVachana";
import AudioSubscription from "./pages/AudioSubscription";
import AudioAdmin from "./pages/AudioAdmin";

export default function AudioApp() {
  return (
    <AudioAccessProvider>
      <AudioAuthProvider>
        <Routes>
          <Route path="/" element={<AudioHome />} />
          <Route path="login" element={<AudioLogin />} />
          <Route path="auth/callback" element={<AudioAuthCallback />} />
          <Route path="books" element={<AudioBooks />} />
          <Route path="books/:bookId" element={<AudioBook />} />
          <Route path="vachana/:vachanaId" element={<AudioVachana />} />
          <Route path="subscription" element={<AudioSubscription />} />
          <Route path="admin" element={<AudioAdmin />} />
          <Route path="*" element={<AudioHome />} />
        </Routes>
      </AudioAuthProvider>
    </AudioAccessProvider>
  );
}
